/**
 * 行情中心标题自动滚动
 */

export function NavScroll(type: string) {
  var tabs: any = document.querySelector(".comm-tabs")
  var tabsWidth = tabs.offsetWidth

  var item: any = $(`#${type}`)
  var itemScrollLeft = item.offset().left - (tabsWidth-60) / 2 + item.width() / 2
  tabs.scrollLeft = itemScrollLeft
}
